import React, { useState } from 'react'

import Dropdown from '@components/shared/form/Dropdown'
import { useSession } from '@stores/globalData/globalData.store'
import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'
import { languages } from '@utils/i18n'

const LocaleSelector: React.FC = () => {
  const session = useSession()
  const [lng, setLng] = useState(session.locale ?? 'en')
  return (
    <Dropdown
      className="mb-2"
      variant="sm"
      value={lng}
      onChange={async (e) => {
        setLng(e.target.value)
        const [resp] = await http.post(ApiRoutes.clientLocalePath(), {
          locale: e.target.value,
          user: session.current_user,
        })
        if (resp) window.location.reload()
      }}
      name="lang">
      {languages.map((lng) => (
        <option value={lng.code} key={lng.code}>
          {lng.label}
        </option>
      ))}
    </Dropdown>
  )
}

export default LocaleSelector
